<template>
  <div class="nx-list-el-tabs">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane name="task" label="诊断任务管理">
        <TaskManage></TaskManage>
      </el-tab-pane>
      <el-tab-pane  name="record" label="单车诊断记录">
        <Record></Record>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import TaskManage from './module/taskManage.vue';
import Record from './module/record.vue';

export default {
  name: 'NewDataServiceUds',
  components: {
    TaskManage,
    Record
  },
  props: {},
  data() {
    return {
      taskNo: '',
      activeName: 'task'
    };
  },
  computed: {},
  watch: { },
  created() {},
  mounted() {
    this.activeName = 'task';
  },
  activated() {

  },
  methods: {
    handleClick(name) {
      // name.$children[0].$refs.nxTable.search(1); // 刷新数据
    },
    // chengeTab(taskNo) {
    //   this.activeName = 'record';
    //   this.taskNo = taskNo;
    // }
  }
};
</script>
<style scoped lang="scss">
</style>
